import { graphql } from "../gql";

export const acceptAgentMessageMutationDoc = graphql(`
  mutation acceptAgentMessage($agentMessageId: UUID!, $revisionId: ID) {
    acceptAgentMessage(
      agentMessageId: $agentMessageId
      revisionId: $revisionId
    ) {
      ...AgentMessageFragment
    }
  }
`);
